var fragranceArr;
if($('.fragrances-select').length){
  fragranceArr = $('.fragrances-select option').map(function(index, elem){
    return {id:$(elem).val(),text: $(elem).text()};
  });
}

var accessoriesArr;
if($('.accessories-select').length){
  accessoriesArr = $('.accessories-select option').map(function(index, elem){
    return {id:$(elem).val(),text: $(elem).text()};
  });
}

var goldVariants ="31257203736670,13026488746078";
var roseGoldVariants = "31257203769438,13026488713310";

$(document).ready(function() {
  
  function formatResultData (data) {
    if (!data.id) return data.text;
    if (data.element.selected) return
    return data.text;
  };
  
  if($('.accessories-selection-wrapper').length){
    var $eventSelect = $(".fragrances-select");
    
    $eventSelect.on("select2:select", function (e) { 
      $eventSelect.prepend('<option value="'+e.params.data.value+'">' +e.params.data.text + '</option>');
    });

    $eventSelect.on("select2:unselect", function (e) { 
      e.params.data.element.remove();
    });
    
    $eventSelect.select2({
      placeholder: 'Select 2 fragrances',
      templateResult: formatResultData,
      tags: true,
      maximumSelectionLength: 2
    });
    
    var $accessoriesSelect = $(".accessories-select");
    
    $accessoriesSelect.on("select2:select", function (e) { 
      $accessoriesSelect.prepend('<option value="'+e.params.data.value+'">' +e.params.data.text + '</option>');
    });
    
    $accessoriesSelect.on("select2:select", function (e) {
      $('#accessories1').val(`Candle Snuffer - ${e.params.data.text}`);
      $('#accessories2').val(`Wick Trimmers - ${e.params.data.text}`);
    });

    $accessoriesSelect.on("select2:unselect", function (e) { 
      e.params.data.element.remove();
    });
    
    $accessoriesSelect.select2({
      placeholder: `Select accessories' colour`,
      templateResult: formatResultData,
      tags: true,
      maximumSelectionLength: 1,
      minimumResultsForSearch: -1
    });
    
  } else {
    var $eventSelect = $(".fragrances-select");
    
    $eventSelect.on("select2:select", function (e) { 
      $eventSelect.prepend('<option value="'+e.params.data.value+'">' +e.params.data.text + '</option>');
    });

    $eventSelect.on("select2:unselect", function (e) { 
      e.params.data.element.remove();
    });
    
    var isCandleLeatherHolder = $('.candle-leather-holder-product').length;
    if(isCandleLeatherHolder){
      $eventSelect.select2({
        placeholder: 'Select 1 fragrance',
        templateResult: formatResultData,
        tags: true,
        maximumSelectionLength: 1
      });
      // var monogramTextColour = $('.monogram-text-colour-select');
      // monogramTextColour.select2({
      //   placeholder: 'Select monogram text colour',
      //   tags: true,
      //   maximumSelectionLength: 1
      // });
    } else {
      $eventSelect.select2({
        placeholder: 'Select 3 fragrances',
        templateResult: formatResultData,
        tags: true,
        maximumSelectionLength: 3,
      }); 
    }
  }
});

function checkValidation(){
  if($('.accessories-selection-wrapper').length){
    var isFragranceSelection = $('.fragrances-select').length;
    var isAccessortiesSelection = $('.accessories-select').length;
    if(isFragranceSelection && isAccessortiesSelection){
      var fragrances_validation = 0;
      var accessories_validation = 0;
      var fragrances = new Array();
      var accessories = new Array();
      $(".fragrances-select option:selected").each(function(index){
        fragrances.push($(this).text());
      });
      /*Checking fragrances validation*/
      if(fragrances){
        if(fragrances.length == 2){
          fragrances_validation = 1;
          /*Validation ok*/	 
          $('#fragrance1').val(fragrances[0]);
          $('#fragrance2').val(fragrances[1]);    
          $('.fragrances-selection-wrapper').removeClass('selection-error');
        }else{
          $('.fragrances-selection-wrapper').addClass('selection-error');
          console.log("Fragrances selection error");
        } 
      }
      $(".accessories-select option:selected").each(function(index){
        accessories.push($(this).text());
      });
      /*Checking accessories validation*/
      if(accessories){
        if(accessories.length <= 2 && accessories.length > 0){
          accessories_validation = 1;
          /*Validation ok*/	 
          //$('#accessories1').val(accessories[0]);
          //$('#accessories2').val(accessories[1]);    
          $('.accessories-selection-wrapper').removeClass('selection-error');
        } else {
          $('.accessories-selection-wrapper').addClass('selection-error');
          console.log("Accessories selection error");
        } 
      }
      
      if(fragrances_validation == 1 && accessories_validation == 1){
        return true;
      } else {
        console.log("Validation Error");
        return false;
      }
    } else {
      return true;
    }
  } else {
    var isFragranceSelection = $('.fragrances-select').length;
    var fragrancesLength;
    var isCandleLeatherHolder = $('.candle-leather-holder-product').length;
    if(isCandleLeatherHolder){
      fragrancesLength = 1;
    } else {
      fragrancesLength = 3;
    }
    if(isFragranceSelection){
      var fragrances_validation = 0;
      var accessories_validation = 0;
      var fragrances = new Array();
      $(".fragrances-select option:selected").each(function(index){
        fragrances.push($(this).text());
      });
      /*Checking fragrances validation*/
      if(fragrances){
        if(fragrances.length == 3){
          fragrances_validation = 1;
          /*Validation ok*/	 
          $('#fragrance1').val(fragrances[0]);
          $('#fragrance2').val(fragrances[1]);
          $('#fragrance3').val(fragrances[2]);
          $('.fragrances-selection-wrapper').removeClass('selection-error');
        } else if(fragrances.length == 1 && isCandleLeatherHolder){
          fragrances_validation = 1;
          /*Validation ok*/	 
          $('#fragrance1').val(fragrances[0]);
          $('.fragrances-selection-wrapper').removeClass('selection-error');
          //var monogramColour = $(".monogram-text-colour-select option:selected").text();
          //console.log('monogramColour',monogramColour);
          var monogramText, monogramValidation;
          if($('.candle-monogram input').length){
            monogramText = $('.candle-monogram input').val();
            monogramValidation = $('.candle-monogram input')[0].checkValidity();
            
            if(monogramText){
              if(!monogramValidation){
                fragrances_validation = 0;
                $('.candle-monogram input').addClass('selection-error');
              } else {
                fragrances_validation = 1;
                $('.candle-monogram input').removeClass('selection-error');
              }            
              //$('#monogram-text-colour').val(monogramColour);
            }
          }
        } else{
          $('.fragrances-selection-wrapper').addClass('selection-error');
          console.log("Fragrances selection error");
        } 
      }
      if(fragrances_validation == 1 ){
        return true;
      }else{
        console.log("Validation Error");
        return false;
      }
    } else {
      return true;
    }
  }
}

function getGiftBoxProductData(){
  if($('.accessories-select').length || $('.fragrances-select').length){
    var arr = [];
    var dataArray = $('[data-product-form]').serializeArray();
    var dataObj = {};
    var properties = {};
    var handle = Theme.routes.product_handle;
    var timestamp = new Date().getTime();
    
    $(dataArray).each(function(i, field){
      dataObj[field.name] = field.value;
      if(field.name.indexOf('properties') > -1){
          properties[field.name]= field.value
      }
    });

    if(handle === "travel-candle-set" || handle === "gift-box-set" || handle === "premium-candle-gift-set"){  
      dataObj['properties'] = {
        _bundle_id: timestamp
      };
    }
    console.log('data',dataObj);

    if(properties){
      arr.push(dataObj);
    } else {
      arr.push({id: dataObj.id, quantity: dataObj.quantity});
    }
    
    if($('.fragrances-select').length){
      $(".fragrances-select option:selected").each(function(index){
        var selectedText = $(this).text();
        var selectedObj = fragranceArr.filter(function(index,obj){
          return obj.text == selectedText;
        });
        if(handle === "travel-candle-set" || handle === "gift-box-set" || handle === "premium-candle-gift-set"){  
        arr.push({id:selectedObj[0].id, properties: {_bundle_id: timestamp}});
        } else {
        arr.push({id:selectedObj[0].id});  
        }
      });
    }
    
    if($('.accessories-select').length){
      var selectedAccessoriesColor = $(".accessories-select option:selected").val();
      // var accessoriesVariants;
      // if(selectedAccessoriesColor == "gold"){
      // 	accessoriesVariants = goldVariants.split(',');
      // } else if(selectedAccessoriesColor == "rose gold"){
      // 	accessoriesVariants = roseGoldVariants.split(',');        
      // }
      var accessoriesVariants = $(".accessories-select option:selected").data('variant-ids').split(',');
      accessoriesVariants.forEach((variant) => {
        if(handle === "gift-box-set" || handle === "premium-candle-gift-set"){  
          arr.push({id:variant, properties: {_bundle_id: timestamp}});
        }else {
          arr.push({id:variant});
        }
      });
    }
    
//     if($('.accessories-select').length){
//       $(".accessories-select option:selected").each(function(index){
//         var selectedText = $(this).text();
//         var selectedObj = accessoriesArr.filter(function(index,obj){
//           return obj.text == selectedText;
//         });
//         arr.push({id:selectedObj[0].id});
//       });
//     }
    
    const counts = {};
    arr.forEach(function (x) { counts[x.id] = (counts[x.id] || 0) + 1; });
    
    var newArr = arr.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
    
    for(var i = 0;i < newArr.length; i++){
      newArr[i].quantity = counts[newArr[i].id] * parseInt($('.product-quantity-input').val());
    }
    
    let formData = {'items': newArr.reverse()};
    console.log('formdata',formData);
    return formData;
  }
}

function removeItems(itemsArray) {
  var qty = 0;
  var data = { updates: {} };
 
  for (i = 0; i < itemsArray.length; i++) {
    data.updates[itemsArray[i]] = qty;
  }
  
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function() { 
      window.location.reload();
    }
  });
}  

$(document).ready(function(){
  $('.hero_slideshow_section .hero_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:".hero_slideshow_section .slick-prev",
    nextArrow:".hero_slideshow_section .slick-next"
  });

  $(document).on('click','.remove-bundle', function (e) {
    console.log('test');
    e.preventDefault();
    var bundleID = $(this).parents('.table-row').attr('data-bundle-id');
    var itemsArray = [];
    $('[data-bundle-id='+bundleID+']').each(function (index, element) {
      var key = $(element).data('cart-item-key');
      itemsArray.push(key);
    });
    removeItems(itemsArray);
  });

  $(document).on('click','.cart-mini-remove-bundle', function (e) {
    e.preventDefault();
    var bundleID = $(this).parents('.cart-mini-item').attr('data-cart-mini-bundle-id');
    var itemsArray = [];
    $('[data-cart-mini-bundle-id='+bundleID+']').each(function (index, element) {
      var key = $(element).data('cart-mini-item-remove');
      itemsArray.push(key);
    });
    console.log('itemsArray',itemsArray);
    removeItems(itemsArray);
  });
  
});